export default class ClearMergeProfiles {
  constructor(context) {
    this.context = context;
  }

  run() {
    this.context.stores.customerMerge.remove();
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/customer/clear_merge_profiles.js